import React from 'react'
import Background from 'components/Background'

const TokensViewBackground = () => (
  <Background height="45vh" />
)
export default TokensViewBackground
